<h3>{{ 'step_forConfirmation_new_name' | i18n }}</h3>
<form *ngIf="!loading" class="k-form" [formGroup]="form">
  <fieldset class="k-form-fieldset">
    <kendo-formfield showHint="initial" showErrors="initial">
      <kendo-label [for]="title" [text]=" 'step_new_label_title' | i18n "></kendo-label>
      <input kendoTextBox formControlName="title" #title required />
      <kendo-formhint>{{ 'step_new_formhint_title' | i18n }}</kendo-formhint>
      <kendo-formerror>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield showErrors="initial">
      <kendo-label [for]="responsible" [text]="'step_details_responsible' | i18n"></kendo-label>
      <sp-people-picker #responsible formControlName="responsible"></sp-people-picker>
      <kendo-formerror>
      </kendo-formerror>
    </kendo-formfield>
    <common-switch-form-field [form]="form"></common-switch-form-field>
    <kendo-formfield showErrors="initial">
      <kendo-label [for]="comment" [text]="'step_details_comment' | i18n"></kendo-label>
      <textarea kendoTextArea formControlName="comment" #comment [autoSize]="true"></textarea>
      <kendo-formerror>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield showErrors="initial">
      <kendo-label [for]="duration" [text]="'circ_template_label_duration' | i18n"></kendo-label>
      <kendo-numerictextbox [title]="'circ_template_label_duration' | i18n" formControlName="duration" decimals="0" #duration format="n0" [min]="0"></kendo-numerictextbox>
      <kendo-formhint>{{ 'circ_template_formhint_duration' | i18n }}</kendo-formhint>
    </kendo-formfield>
    <step-permissions [form]="form"></step-permissions>
    <div class="k-form-buttons">
      <ece-btn-primary (click)="save()" [text]=" 'step_new_button_save' | i18n"></ece-btn-primary>
      <ece-btn (click)="abort()" [text]=" 'step_new_button_abort' | i18n"></ece-btn>
    </div>
  </fieldset>
</form>
